import React from "react";
import {
  DetailsList,
  DetailsListLayoutMode,
  IColumn,
  SelectionMode,
} from "@fluentui/react/lib/DetailsList";
import { AdminAction } from "./AdminStore";

interface ActionListProps {
  actions: AdminAction[];
  onSelect: (action: AdminAction) => void;
}

export const ActionList: React.FunctionComponent<ActionListProps> = ({ actions, onSelect }) => {
  const columns: IColumn[] = [
    {
      key: "createdAt",
      name: "Date",
      minWidth: 160,
      maxWidth: 180,
      onRender: (item: AdminAction) => new Date(item.createdAt).toLocaleString(),
    },
    {
      key: "leadEmail",
      name: "Email",
      fieldName: "leadEmail",
      minWidth: 180,
      maxWidth: 240,
    },
    {
      key: "name",
      name: "Name",
      minWidth: 140,
      maxWidth: 180,
      onRender: (item: AdminAction) => `${item.leadFirstName} ${item.leadLastName}`,
    },
    {
      key: "actionCode",
      name: "Action Code",
      fieldName: "actionCode",
      minWidth: 120,
      maxWidth: 160,
    },
    {
      key: "offerTitle",
      name: "Offer Title",
      fieldName: "offerTitle",
      minWidth: 140,
      maxWidth: 200,
    },
    {
      key: "leadSource",
      name: "Lead Source",
      fieldName: "leadSource",
      minWidth: 120,
      maxWidth: 160,
    },
  ];

  return (
    <DetailsList
      items={actions}
      columns={columns}
      setKey="actions"
      layoutMode={DetailsListLayoutMode.justified}
      selectionMode={SelectionMode.none}
      onItemInvoked={(item) => onSelect(item as AdminAction)}
    />
  );
};
